import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { CarbonFootprintLocationBasedExportViewModel } from './types/carbonFootprintLocationBasedExportViewModel';
import { CarbonFootprintMarketBasedExportViewModel } from './types/carbonFootprintMarketBasedExportViewModel';
import { CarbonFootprintRequest } from './types/carbonFootprintRequest';
import { PowerConsumptionMix } from './types/powerConsumptionMix';
import { ResidualMixViewModel } from './types/residualMixViewModel';

/**
 * @internal
 */
export class ApiCarbonAccounting extends ApiBaseMidBack {
  @ApiOptions({ interceptErrors: false })
  getPowerCarbonAccounting(params: ParamsAdapter) {
    return this.get<PowerConsumptionMix[]>('/carbon-footprint/location-based/power-consumption-mix/json', params);
  }

  @ApiOptions({ interceptErrors: false })
  getPointsCarbonAccounting(params: ParamsAdapter) {
    return this.post<CarbonFootprintLocationBasedExportViewModel[]>('/carbon-footprint/location-based/export/json', params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  getPointsCarbonAccountingExcel(params: ParamsAdapter) {
    return this.post<HttpResponse<Blob>>('/carbon-footprint/location-based/export/excel', params);
  }

  @ApiOptions({ interceptErrors: false })
  getCarbonResidualMix(params: ParamsAdapter) {
    return this.get<ResidualMixViewModel>('/carbon-footprint/residual-mix', params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  exportLocationBasedPowerPercentShareExcel(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>('/carbon-footprint/location-based/power-consumption-mix/percent-share/export/excel', params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  exportMarketBasedPowerExcel(params: ParamsAdapter) {
    return this.post<HttpResponse<Blob>>('/carbon-footprint/market-based/power/export/excel', params);
  }

  @ApiOptions({ responseType: 'text' })
  getCarbonLocationBasedCSV(params: CarbonFootprintRequest) {
    return this.post<string>(`/carbon-footprint/location-based/export/csv`, new DefaultParams(params));
  }

  getMarketBasedPowerJson(params: ParamsAdapter) {
    return this.post<CarbonFootprintMarketBasedExportViewModel>('/carbon-footprint/market-based/power/export/json', params);
  }
}
